<template>
  <div class="container py-5">

    <h2 class="page-title mb-4">Database Concepts</h2>

    <p class="lead">
      A database is an organized collection of data that can be easily accessed,
      managed, and updated.
    </p>

    <div class="card-section mt-4">
      <h4 class="section-title">🗂 What is a Database?</h4>
      <p>
        It is a structured system for storing information electronically with
        efficient data management.
      </p>
    </div>

    <div class="card-section mt-4">
      <h4 class="section-title">💽 Types of Databases</h4>
      <ul>
        <li>Relational Database (SQL)</li>
        <li>NoSQL Database</li>
        <li>Hierarchical Database</li>
        <li>Network Database</li>
      </ul>
    </div>

    <div class="card-section mt-4">
      <h4 class="section-title">📌 Examples</h4>
      <ul>
        <li>MySQL</li>
        <li>Oracle</li>
        <li>MongoDB</li>
        <li>Microsoft Access</li>
      </ul>
    </div>

  </div>
</template>

<script>
export default {
  name: "DatabaseConcept",
};
</script>

<style scoped>
.page-title { font-weight: 800; color: #2563eb; }
.lead { color: #374151; font-size: 1.1rem; }
.card-section {
  background: #fff; padding: 20px; border-radius: 16px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.08);
  border-left: 4px solid #2563eb;
}
.section-title { color: #1e40af; font-weight: 600; }
</style>
